// Días para la ruta de la empresa (23-oct-2026): de mañana en adelante, de lunes a sábado.
const NOMBRES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const IDS = [null, 'LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO'];
const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const fecha = s => { const [y, m, d] = String(s).slice(0, 10).split('-').map(Number); return new Date(y, m - 1, d); };

export function proximosDias(n = 6) {
    const d = new Date(); d.setHours(0, 0, 0, 0);
    const out = [];
    while (out.length < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) out.push(iso(d)); }
    return out;
}
export const diaLargo = s => { const d = fecha(s); return `${NOMBRES[d.getDay()]} ${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`; };
export const diaCorto = s => { const d = fecha(s); return { dia: NOMBRES[d.getDay()].slice(0, 3), num: d.getDate() }; };
export const idSemana = s => IDS[fecha(s).getDay()];
